<template>
    <div id="app">
        <Navigation v-if="authUser && appUser"></Navigation>
    	<router-view/>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Navigation from './components/Navigation.vue'

  export default {
    components: { Navigation },
    computed: {
      ...mapState(['authUser', 'appUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue